// ========================================
// CONFIGURACIÓN CENTRALIZADA
// ========================================

// 🔐 Configuración de APIs y servicios externos
export const CONFIG = {
  // Google Services
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  GOOGLE_ANALYTICS_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
  RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  
  // Remove.bg API
  REMOVE_BG_API_KEY: process.env.REACT_APP_REMOVE_BG_API_KEY,
  
  // Firebase Configuration
  FIREBASE: {
    API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
    AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
    MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
  },
  
  // Cloud Functions URLs (desde .env para no exponer URLs en el código)
  // REACT_APP_CLOUD_FUNCTIONS_BASE_URL = base; si está definida, getCloudFunctionUrl usa base + nombreFuncion.
  // O definir cada URL en .env con REACT_APP_CF_<NOMBRE> (ej: REACT_APP_CF_SEND_ORDER_INVOICE_BY_EMAIL).
  CLOUD_FUNCTIONS: {
    BASE_URL: process.env.REACT_APP_CLOUD_FUNCTIONS_BASE_URL,
    VERIFY_RECAPTCHA: process.env.REACT_APP_VERIFY_RECAPTCHA_URL,
    CREATE_PREFERENCE: process.env.REACT_APP_CREATE_PREFERENCE_URL,
    HANDLE_PAYMENT_NOTIFICATION: process.env.REACT_APP_HANDLE_PAYMENT_NOTIFICATION_URL,
    URLS: {
      testAfipConnection: process.env.REACT_APP_CF_TEST_AFIP_CONNECTION,
      checkAfipConfig: process.env.REACT_APP_CF_CHECK_AFIP_CONFIG,
      basicTest: process.env.REACT_APP_CF_BASIC_TEST,
      generateAfipInvoiceReal: process.env.REACT_APP_CF_GENERATE_AFIP_INVOICE_REAL,
      generateAfipCreditNoteReal: process.env.REACT_APP_CF_GENERATE_AFIP_CREDIT_NOTE_REAL,
      getInvoiceHistory: process.env.REACT_APP_CF_GET_INVOICE_HISTORY,
      validateCuitAfip: process.env.REACT_APP_CF_VALIDATE_CUIT_AFIP,
      diagnoseWSAAToken: process.env.REACT_APP_CF_DIAGNOSE_WSAA_TOKEN,
      testGenerateInvoiceStep: process.env.REACT_APP_CF_TEST_GENERATE_INVOICE_STEP,
      handlePaymentNotification: process.env.REACT_APP_CF_HANDLE_PAYMENT_NOTIFICATION,
      createPreference: process.env.REACT_APP_CF_CREATE_PREFERENCE,
      verifyReCaptcha: process.env.REACT_APP_CF_VERIFY_RECAPTCHA,
      chatAssistant: process.env.REACT_APP_CF_CHAT_ASSISTANT,
      generateNewsletterTemplate: process.env.REACT_APP_CF_GENERATE_NEWSLETTER_TEMPLATE,
      sendOrderInvoiceByEmail: process.env.REACT_APP_CF_SEND_ORDER_INVOICE_BY_EMAIL,
      sendOrderCustomerEmail: process.env.REACT_APP_CF_SEND_ORDER_CUSTOMER_EMAIL,
      getWallStreetChartAggregates: process.env.REACT_APP_CF_GET_WALL_STREET_CHART_AGGREGATES,
      getSalesHistoryData: process.env.REACT_APP_CF_GET_SALES_HISTORY_DATA,
      prepareNewsletterCampaign: process.env.REACT_APP_CF_PREPARE_NEWSLETTER_CAMPAIGN,
      processNewsletterCampaignQueue: process.env.REACT_APP_CF_PROCESS_NEWSLETTER_CAMPAIGN_QUEUE,
      sendNewsletterTest: process.env.REACT_APP_CF_SEND_NEWSLETTER_TEST,
      pauseNewsletterCampaign: process.env.REACT_APP_CF_PAUSE_NEWSLETTER_CAMPAIGN,
      deleteNewsletterCampaign: process.env.REACT_APP_CF_DELETE_NEWSLETTER_CAMPAIGN,
      saveNewsletterGroup: process.env.REACT_APP_CF_SAVE_NEWSLETTER_GROUP,
      deleteNewsletterGroup: process.env.REACT_APP_CF_DELETE_NEWSLETTER_GROUP,
      getNewsletterGroupMembers: process.env.REACT_APP_CF_GET_NEWSLETTER_GROUP_MEMBERS,
      removeNewsletterGroupMember: process.env.REACT_APP_CF_REMOVE_NEWSLETTER_GROUP_MEMBER,
      listNewsletterUnsubscribed: process.env.REACT_APP_CF_LIST_NEWSLETTER_UNSUBSCRIBED,
      deleteNewsletterUnsubscribed: process.env.REACT_APP_CF_DELETE_NEWSLETTER_UNSUBSCRIBED,
      findNewsletterEmail: process.env.REACT_APP_CF_FIND_NEWSLETTER_EMAIL,
      purgeNewsletterEmail: process.env.REACT_APP_CF_PURGE_NEWSLETTER_EMAIL
    }
  }
};

// ⚠️ Validación de configuración crítica
export const validateConfig = () => {
  const errors = [];
  
  // Verificar APIs críticas
  if (!CONFIG.GOOGLE_MAPS_API_KEY) {
    errors.push('REACT_APP_GOOGLE_MAPS_API_KEY no está configurada');
  }
  
  if (!CONFIG.RECAPTCHA_SITE_KEY) {
    errors.push('REACT_APP_RECAPTCHA_SITE_KEY no está configurada');
  }
  
  if (!CONFIG.REMOVE_BG_API_KEY) {
    console.warn('⚠️ REACT_APP_REMOVE_BG_API_KEY no está configurada - funcionalidad de remoción de fondo deshabilitada');
  }
  
  // Verificar configuración de Firebase
  const firebaseConfig = CONFIG.FIREBASE;
  if (!firebaseConfig.API_KEY || !firebaseConfig.PROJECT_ID) {
    errors.push('Configuración de Firebase incompleta');
  }
  
  // Verificar URLs de Cloud Functions (BASE_URL o al menos una URL en .env)
  const hasBaseUrl = !!CONFIG.CLOUD_FUNCTIONS.BASE_URL;
  const hasAnyDirectUrl = CONFIG.CLOUD_FUNCTIONS.URLS && Object.values(CONFIG.CLOUD_FUNCTIONS.URLS).some(Boolean);
  if (!hasBaseUrl && !hasAnyDirectUrl) {
    errors.push('Configurá REACT_APP_CLOUD_FUNCTIONS_BASE_URL o las variables REACT_APP_CF_* en .env');
  }
  
  if (!CONFIG.CLOUD_FUNCTIONS.VERIFY_RECAPTCHA) {
    errors.push('REACT_APP_VERIFY_RECAPTCHA_URL no está configurada');
  }
  
  if (!CONFIG.CLOUD_FUNCTIONS.CREATE_PREFERENCE) {
    errors.push('REACT_APP_CREATE_PREFERENCE_URL no está configurada');
  }
  
  if (!CONFIG.CLOUD_FUNCTIONS.HANDLE_PAYMENT_NOTIFICATION) {
    errors.push('REACT_APP_HANDLE_PAYMENT_NOTIFICATION_URL no está configurada');
  }
  
  if (errors.length > 0) {
    console.error('❌ Errores de configuración:', errors);
    return false;
  }
  
  console.log('✅ Configuración validada correctamente');
  return true;
};

// 🔧 Obtiene la URL de una Cloud Function: primero URL directa (Cloud Run), sino BASE_URL + nombre
export const getCloudFunctionUrl = (functionName) => {
  const direct = CONFIG.CLOUD_FUNCTIONS.URLS?.[functionName];
  if (direct) return direct;
  const base = CONFIG.CLOUD_FUNCTIONS.BASE_URL || process.env.REACT_APP_CLOUD_FUNCTIONS_BASE_URL;
  if (base) return `${base.replace(/\/$/, '')}/${functionName}`;
  throw new Error('No hay URL configurada para Cloud Functions');
};

// 🔧 Función helper para verificar si estamos en desarrollo
export const isDevelopment = () => {
  return process.env.NODE_ENV === 'development';
};

// 🔧 Función helper para logging seguro
export const secureLog = (message, data = null) => {
  if (isDevelopment()) {
    if (data) {
      console.log(message, data);
    } else {
      console.log(message);
    }
  }
  // En producción, podrías enviar logs a un servicio externo
}; 